import { navigate } from "gatsby";

const actions = {
  NAVIGATE_BACK: "NAVIGATE_BACK",
  SET_RESUME_PARAM: "SET_RESUME_PARAM",
};


export const setResumeParameter = () => {
  const queryString = window.location.search;
  const hash = window.location.hash;
  const nextSearch = new URLSearchParams(queryString);
  nextSearch.set('resume', 'true');
  const url = `/room/?${nextSearch.toString()}${hash}`;
  navigate(url);
};

export const handleSugarcubeNavigationEvent =
  ({ data = {} }) => {
    if (process.env.GATSBY_ENV !== "production") {
      console.log("Sugarcube event:", data);
    }

    switch (data.action) {
      case actions.NAVIGATE_BACK:
        navigate("/");
        break;
      case actions.SET_RESUME_PARAM:
        setResumeParameter();
        break;

      default:
        break;
    }
  };
